<template>
  <div>
    <!-- <Loading v-if="isLoading"></Loading> -->
    <div class="home">
      <LandingPageSection />
      <ShowCaseSection />
      <ViewMoreSection />
      <ServicesAndBrands />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import Loading from "@/views/Loading";
import LandingPageSection from '@/components/LandingPageSection';
import ShowCaseSection from '@/components/ShowCaseSection';
import ViewMoreSection from '@/components/ViewMoreSection';
import ServicesAndBrands from '@/components/ServicesAndBrands';

export default {
  name: 'home',
  components: {
    LandingPageSection,
    ShowCaseSection,
    ViewMoreSection,
    ServicesAndBrands,
  },

  data: () => {
    return {
      isLoading: true,
    };
  },
};
</script>

<style scoped>
.home {
  margin-top: 90px;
}
</style>
